import { z } from 'zod';
import { allHtmlParsers } from '@utils/ast';
import { bindInputMaker } from '../util.make-input.js';

const makeInput = bindInputMaker();
const inTextDropzoneInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("in-text-dropzone").default("in-text-dropzone"),
      tileId: z.string().default(""),
      tileKey: z.string().default("")
    }),
    shouldValidate: node => node.validation.acceptedTileKeys.length > 0,
    validate: (node, entry) => node.validation.acceptedTileKeys.includes(entry.tileKey),
    parseLegacyDetailItem: (item, context) => {
      if (context.relatedTask.taskType === "PlaceItems" && context.relatedTask.answerType === "InText" && typeof item === "number") {
        const typedTask = context.relatedTask;
        const tile = typedTask.__orderedTiles[context.indexInDetails];
        const selectedDropzoneForTile = typedTask.content.filter(it => it.nodeType === "in-text-dropzone-input")[item];
        if (tile && selectedDropzoneForTile) {
          return [selectedDropzoneForTile.id, {
            type: "in-text-dropzone",
            tileId: tile.id,
            tileKey: tile.itemKey
          }];
        }
      }
      return undefined;
    }
  },
  parsers: {
    dropzone: (node, context) => {
      const inputContext = context.extra;
      const index = Array.from(node.parentElement?.children ?? []).filter(child => !Object.keys(allHtmlParsers).includes(child.tagName.toLowerCase())).indexOf(node);
      const correctAnswerIndex = (() => {
        const value = Number(node.getAttribute("correctAnswer"));
        if (Number.isNaN(value)) {
          return undefined;
        }
        return value;
      })();
      const correctTile = typeof correctAnswerIndex === "number" ? inputContext.tiles[correctAnswerIndex] : null;

      //
      // STEP: Ensure that all additional tiles that are identical to the
      // accepted tiles are also included in the entire set of allowed tiles
      // for the dropzone
      //
      const acceptedTileKeys = inputContext.tiles.filter(it => {
        switch (true) {
          case it.type === "Audio" && correctTile?.type === "Audio":
            return it.src === correctTile?.src && it.title === correctTile?.title;
          case it.type === "Image" && correctTile?.type === "Image":
            return it.src === correctTile?.src && it.title === correctTile?.title;
          case it.type === "Text" && correctTile?.type === "Text":
            return it.text === correctTile?.text;
          default:
            return false;
        }
      }).map(it => it.itemKey || it.id);
      return {
        id: `${inputContext.taskId}-${index}`,
        nodeType: "in-text-dropzone-input",
        validation: {
          acceptedTileKeys
        }
      };
    }
  }
});

export { inTextDropzoneInput };
//# sourceMappingURL=input.dropzone.js.map
